module.exports = {
    LOGIN: "LOGIN",
    LOGOUT: 'LOGOUT',
    AUTH: 'AUTH_LOADING'
}